import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bancos/notaCredito';
import NCForm from './NCFormTabs';


const ms2p = (state) => {
  return {
    ...state.nota_credito,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(NCForm);
